import { forwardRef, useState } from 'react'

const TextArea = forwardRef(({ 
  label,
  error,
  maxLength,
  showCount = false,
  rows = 4,
  className = '',
  onChange,
  ...props 
}, ref) => {
  const [charCount, setCharCount] = useState(props.value?.length || props.defaultValue?.length || 0)

  const handleChange = (e) => {
    if (maxLength && e.target.value.length > maxLength) {
      e.target.value = e.target.value.substring(0, maxLength)
    }
    setCharCount(e.target.value.length)
    onChange?.(e)
  }

  return (
    <div className="form-group">
      {label && (
        <label className="form-label">
          {label}
          {props.required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <textarea
        ref={ref}
        rows={rows}
        onChange={handleChange}
        className={`
          w-full px-3 py-2 border rounded-md transition-colors resize-y
          ${error 
            ? 'border-red-500 focus:ring-red-500' 
            : 'border-gray-300 focus:ring-rdi-blue'}
          focus:outline-none focus:ring-2 focus:border-transparent
          disabled:bg-gray-100 disabled:cursor-not-allowed
          ${className}
        `}
        {...props}
      />
      <div className="flex justify-between mt-1">
        {error && (
          <p className="form-error">{error}</p>
        )}
        {(showCount || maxLength) && (
          <p className={`text-sm ml-auto ${charCount >= (maxLength || Infinity) ? 'text-red-500' : 'text-gray-500'}`}>
            {charCount}{maxLength ? `/${maxLength}` : ''}
          </p>
        )}
      </div>
    </div>
  )
})

TextArea.displayName = 'TextArea'

export default TextArea
